module.exports = __webpack_public_path__ + "static/img/nobooklist.6127846.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nobooklist.png
// module id = bUjj
// module chunks = 46